/** Temporary Apollo enrich payload for UI testing. Replace with API response later. */
export const APOLLO_COMPANY_TEST_PAYLOAD = {
  organization: {
    id: "5e66b6381e05b4008c8331b8",
    name: "Apollo.io",
    website_url: "http://www.apollo.io",
    blog_url: null,
    angellist_url: null,
    linkedin_url: "https://www.linkedin.com/company/apolloio",
    twitter_url: "https://x.com/useapolloio",
    facebook_url: "https://www.facebook.com/example-company",
    primary_phone: {},
    founded_year: 2015,
    publicly_traded_symbol: "TCS.NS",
    publicly_traded_exchange: "NSE",
    logo_url:
      "https://zenprospect-production.s3.amazonaws.com/uploads/pictures/79049be00ff8e398b5935de8/picture",
    primary_domain: "apollo.io",
    industry: "information technology & services",
    keywords: [
      "sales engagement",
      "lead generation",
      "predictive analytics",
      "sales intelligence",
      "b2b data",
    ],
    estimated_num_employees: 1600,
    industries: ["information technology & services"],
    secondary_industries: [],
    raw_address:
      "415 Mission St, Floor 37, San Francisco, California 94105, US",
    street_address: "415 Mission St",
    city: "San Francisco",
    state: "California",
    postal_code: "94105-2301",
    country: "United States",
    owned_by_organization_id: null,
    seo_description:
      "Search, engage, and convert over 240 million contacts at over 30 million companies with Apollo's sales intelligence and engagement platform.",
    short_description:
      "testing frontend Apollo.io combines a buyer database of over 270M contacts and powerful sales engagement and automation tools in one, easy to use platform. Trusted by over 160,000 companies including Autodesk, Rippling, Deel, Jasper.ai, Divvy, and Heap, Apollo has more than one million users globally. By helping sales professionals find their ideal buyers and intelligently automate outreach, Apollo helps go-to-market teams sell anything.\n\nCelebrating a $100M Series D Funding Round 🦄",
    suborganizations: [],
    num_suborganizations: 0,
    annual_revenue_printed: "100M",
    annual_revenue: 100000000,
    total_funding: 251200000,
    total_funding_printed: "251.2M",
    latest_funding_round_date: "2023-08-01T00:00:00.000+00:00",
    latest_funding_stage: "Series D",
    funding_events: [
      {
        id: "6574c1ff9b797d0001fdab1b",
        date: "2023-08-01T00:00:00.000+00:00",
        news_url: null,
        type: "Series D",
        investors:
          "Bain Capital Ventures, Sequoia Capital, Tribe Capital, Nexus Venture Partners",
        amount: "100M",
        currency: "$",
      },
      {
        id: "624f4dfec786590001768016",
        date: "2022-03-01T00:00:00.000+00:00",
        news_url: null,
        type: "Series C",
        investors:
          "Sequoia Capital, Tribe Capital, Nexus Venture Partners, NewView Capital",
        amount: "110M",
        currency: "$",
      },
      {
        id: "5ffe93caa54d75077c59acef",
        date: "2018-06-26T00:00:00.000+00:00",
        news_url:
          "https://techcrunch.com/2018/06/26/yc-grad-zenprospect-rebrands-as-apollo-lands-7-m-series-a/",
        type: "Series A",
        investors: "Nexus Venture Partners, Social Capital, Y Combinator",
        amount: "7M",
        currency: "$",
      },
    ],
    technology_names: ["AI", "Salesforce", "Hubspot", "Stripe", "Python"],
    current_technologies: [
      { uid: "ai", name: "AI", category: "Other" },
      {
        uid: "salesforce",
        name: "Salesforce",
        category: "Customer Relationship Management",
      },
      { uid: "hubspot", name: "Hubspot", category: "Marketing Automation" },
    ],
    departmental_head_count: {
      engineering: 228,
      sales: 177,
      marketing: 36,
      operations: 28,
      support: 30,
    },
    organization_headcount_six_month_growth: 0.123,
    organization_headcount_twelve_month_growth: 0.246,
    organization_headcount_twenty_four_month_growth: 0.489,
  },
};
